import { useState } from "react";

import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  ITransfersSummary,
  ITransfersOverview,
} from "../../../interfaces-and-types";
import { TSummaryPeriod } from "../../../constants";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

import { View } from "./View";

export interface ITransfersSummaryViewProps extends ISummarySectionViewProps<ITransfersOverview> {}

export const TransfersSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingTransfersSummary,
    // isSuccess: isSuccessTransfersSummary,
    // isError: isErrorTransfersSummary,
    data: transfersSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, ITransfersSummary>(
    [
      "getTransfersSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingTransfersOverviewByPeriod,
    // isSuccess: isSuccessTransfersOverviewByPeriod,
    // isError: isErrorTransfersOverviewByPeriod,
    data: transfersOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    ITransfersOverview
  >(
    [
      "getTransfersOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? transfersSummary?.today
      : summaryPeriod === "past week"
        ? transfersSummary?.past_week
        : summaryPeriod === "past month"
          ? transfersSummary?.past_month
          : summaryPeriod === "custom"
            ? transfersOverviewByPeriod
            : transfersSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingTransfersOverviewByPeriod
      : isLoadingTransfersSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
